<template>
    <div class="student-portal-dashboard" :class="{ dark: dark }">
        <Banner :view="ViewMode" :data="dataCourses" :bannerPortal="bannerPortal"></Banner>

        <div class="student-portal-dashboard__inner">
            <KeepWatchingSection />

            <Content
                :view="ViewMode"
                :data="dataCourses"
                :hasReady="hasReady"
            ></Content>
        </div>
    </div>
</template>
<script>
    import apiCourses from '@/utils/portal/course.js';
    import { mapState, mapActions } from 'vuex';

    import Banner from '@/components/Student/Dashboard_Unique/Banner/Banner';
    import Content from '@/components/Student/Dashboard_Unique/Content/Content';
    import KeepWatchingSection from '@/components/Student/Dashboard_Unique/Content/KeepWatchingSection.vue';

    export default {
        data() {
            return {
                ViewMode: false,
                dataCourses: null,
                hasReady: false,
                bannerPortal: null,
            };
        },
        computed: {
            ...mapState(['token', 'listCoursesPortal', 'dark']),
        },
        methods: {
            ...mapActions(['storeListCouresesPortal']),
            alterarValor(novoValor) {
                this.ViewMode = !this.ViewMode;
            },
            async getDataCourses() {
                try {
                    const response = await apiCourses.getDataCourses(
                        this.token
                    );
                    this.storeListCouresesPortal({
                        listCoursesPortal: response,
                    });
                    this.dataCourses = response;
                    this.hasReady = true;
                } catch (error) {
                    const errorMessage = error.response?.data?.message || 'Erro ao carregar dados dos cursos, por favor tente novamente mais tarde.';
                    toast.error(errorMessage);
                }
            },
            async getBannerPortal() {
                try {
                    const response = await apiCourses.getBannerPortal(this.token);
                    console.log(response);
                    this.bannerPortal = response;
                } catch (error) {
                    toast.error('Erro ao carregar banner do portal.');
                    console.error('Erro ao carregar banner do portal:', error);
                }
            },
        },
        watch: {
            ViewMode(novoValor) {
                this.ViewMode = novoValor;
                console.log('Modo de visualização alterado:', novoValor);
            },
        },
        components: {
            Banner,
            Content,
            KeepWatchingSection,
        },
        created() {
            this.getDataCourses();
            // this.getBannerPortal();
        },
    };
</script>
<style scoped>
    .studentPortal {
        min-height: 100vh !important;
    }

    /* Tokens herdados por filhos (banner, cursos) */
    .student-portal-dashboard {
        --dash-bg: #eef0f4;
        --dash-bg-elevated: #ffffff;
        --dash-text: #111827;
        --dash-text-muted: #6b7280;
        --dash-border: rgba(15, 23, 42, 0.08);
        --dash-banner-blend: #eef0f4;
        min-height: 100%;
        background-color: var(--dash-bg);
    }

    .student-portal-dashboard.dark {
        --dash-bg: #0f0e12;
        --dash-bg-elevated: #1a191f;
        --dash-text: #f3f4f6;
        --dash-text-muted: #9ca3af;
        --dash-border: rgba(255, 255, 255, 0.08);
        --dash-banner-blend: #0f0e12;
        background-color: var(--dash-bg);
    }

    .student-portal-dashboard__inner {
        max-width: 1680px;
        margin: 0 auto;
        padding: 0 20px 48px;
        box-sizing: border-box;
    }

    @media (max-width: 768px) {
        .student-portal-dashboard__inner {
            padding: 0 14px 28px;
            padding-left: max(14px, env(safe-area-inset-left));
            padding-right: max(14px, env(safe-area-inset-right));
            padding-bottom: max(28px, env(safe-area-inset-bottom));
        }
    }

    @media (max-width: 480px) {
        .student-portal-dashboard__inner {
            padding: 0 12px 24px;
            padding-left: max(12px, env(safe-area-inset-left));
            padding-right: max(12px, env(safe-area-inset-right));
        }
    }
</style>
